function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.7 6.062l-7.5 4.33v-8.66l7.5 4.33z",
  stroke: "#FED602",
  strokeWidth: 2
});

var SvgIconRunYellow = function SvgIconRunYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 12",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNzAwMiA2LjA2MjE4TDEuMjAwMiAxMC4zOTIzTDEuMjAwMiAxLjczMjA1TDguNzAwMiA2LjA2MjE4WiIgc3Ryb2tlPSIjRkVENjAyIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { SvgIconRunYellow as ReactComponent };